import { useContext } from "react";
import { LayoutContext } from "../context/LayoutContext";
import { Boxes, ClockFading, Handshake } from "lucide-react";
import { Modal } from "./DesignSystem";

export default function TrialEndDialog() {
    const { isTrialEndDialogOpen, closeTrialEndDialog } = useContext(LayoutContext);

    return (
        <div>
            <Modal
                open={isTrialEndDialogOpen}
                onClose={() => closeTrialEndDialog()}
                className="sm:w-[650px] sm:max-w-[650px]"
                primaryButton={{
                    text: "View Plans",
                    color: "blueGradient",
                    icon: <img src="https://app.purchaser.ai/images/icons/upgrade-light.svg" className="h-4 w-4" />,
                    href: "/pricing",
                }}
                secondaryButton={{
                    text: "Talk to Someone",
                    color: "clear",
                    href: "https://purchaser.ai/book-a-demo",
                    target: "_blank",
                }}
            >
                <div className="mb-2 text-2xl font-medium">You've reached the end of your trial!</div>
                <div className="mb-6">
                    Upgrade to a paid plan to continue using Purchaser. If you have RFQs in progress you can still communicate with vendors. If you
                    need more time to evaluate the platform, schedule a demo to get access to a 30 day trial of our Professional Plan.
                </div>
                <div className="mb-12 grid grid-cols-3 gap-6">
                    <div>
                        <div className="bg-bronze-50 mb-2 flex w-fit items-center justify-center rounded-xl p-2.5">
                            <ClockFading className="stroke-bronze-600 h-5 w-4" />
                        </div>
                        <div>Save hours each week by automating purchasing tasks and centralizing sourcing.</div>
                    </div>
                    <div>
                        <div className="bg-bronze-50 mb-2 flex w-fit items-center justify-center rounded-xl p-2.5">
                            <Handshake className="stroke-bronze-600 h-5 w-4" />
                        </div>
                        <div>Works with your current processes and doesn't require a vendor portal.</div>
                    </div>
                    <div>
                        <div className="bg-bronze-50 mb-2 flex w-fit items-center justify-center rounded-xl p-2.5">
                            <Boxes className="stroke-bronze-600 h-5 w-4" />
                        </div>
                        <div>Scales effortlessly with your team size and sourcing needs.</div>
                    </div>
                </div>
            </Modal>
        </div>
    );
}
